import {useEffect, useState} from 'react'
import {isMobile} from '../shared/caps'

export const useIsMobile = () => {
    const [mobile, setMobile] = useState(() => isMobile())
    useEffect(() => {
        const handler = () => setMobile(isMobile())
        window.addEventListener('resize', handler)
        return () => window.removeEventListener('resize', handler)
    }, [])
    return mobile
}
